import { Component, Input, OnChanges, OnInit, ChangeDetectorRef, Output, EventEmitter, ViewChild, ElementRef, QueryList, ViewChildren, AfterContentChecked } from '@angular/core';
import { Car } from '@core/interfaces/cars';
import { LocalStorageService } from '@core/services/local-storage.service';
import { GtmEventService } from '@core/analytics/gtm-events.service';

@Component({
  selector: 'app-show-car',
  templateUrl: './show-car.component.html',
  styleUrls: ['./show-car.component.scss'],
})
export class ShowCarComponent
  implements OnInit, OnChanges, AfterContentChecked
{
  @Input() car!: Car;
  @Input() dataCurrentAccount!: any;
  @Output() countProduct = new EventEmitter<any>();
  @Output() selectConfirmationStock = new EventEmitter<any>();
  @Output() selectConfirmationNoStock = new EventEmitter<any>();
  @Output() deleteProduct = new EventEmitter<any>();
  @Output() deleteCar = new EventEmitter<any>();
  @Output() closeModal = new EventEmitter<void>(); // EventEmitter para cerrar el modal
  readonly bufferValue = 75;
  @ViewChildren('referenceInput', { read: ElementRef })
  referenceInput!: QueryList<ElementRef<HTMLInputElement>>;
  @ViewChild('scrollableContainer', { read: ElementRef })
  scrollableContainer!: ElementRef;
  tempCar!: any;
  unit: any;
  carLength = 0;
  public shouldScroll: boolean = false;
  constructor(
    private readonly _localStorageService: LocalStorageService,
    private readonly ref: ChangeDetectorRef,
    private readonly _gtmEventService: GtmEventService,
  ) {}

  ngOnChanges(): void {
    this.loadLocalData();
    if (this.car) {
      this.carLength = this.car.products ? this.car.products?.length : 0;
    } else {
      this.carLength = 0;
    }
  }

  ngAfterContentChecked() {
    if (
      this.scrollableContainer &&
      this.shouldScroll &&
      this.scrollableContainer.nativeElement.scrollTop > 0
    ) {
      this.scrollableContainer.nativeElement.scrollTop = 0;
      this.shouldScroll = false;
    }
  }

  ngOnInit() {
    this.loadCar();
    this.loadLocalData();
  }

  loadCar(){
    this.tempCar = this.car ? this.car.products.map((obj) => ({ ...obj })) : [];
    
    // Verificar si los productos vienen del historial
    const productsFromHistory = this._localStorageService.getItem('productsFromHistory');
    
    if (productsFromHistory && Array.isArray(productsFromHistory) && productsFromHistory.length > 0) {
      // Usar solo los productos específicos del historial
      const historyProducts = productsFromHistory.map((product) => ({
        ...product,
        item_list_name: product.item_list_name || 'Generales',
        item_list_id: product.item_list_id || 'GENERAL',
      }));

      const priceFields = historyProducts.map(product => ({
        price: product.discountedPrice 
          ? this.currentToNumber(product.discountedPrice)
          : this.currentToNumber(product.salePrice),
        totalPrice: product.discountedPrice 
          ? Number.parseFloat((this.currentToNumber(product.discountedPrice) * this.currentToNumber(product.count)).toFixed(2))
          : Number.parseFloat((this.currentToNumber(product.salePrice) * this.currentToNumber(product.count)).toFixed(2)),
        discount: product.discountedPrice 
          ? Number.parseFloat((this.currentToNumber(product.salePrice) - this.currentToNumber(product.discountedPrice)).toFixed(2))
          : 0
      }));
      
      this._gtmEventService.addProductCartEvent(
        'Ok, Entendido',
        historyProducts,
        priceFields
      );
      
      // Limpiar el marcador después de enviar el evento
      this._localStorageService.removeItem('productsFromHistory');
    }
  }

  currentToNumber(current: any): number {
    if (current) {
      if (typeof current === 'string') {
        return Number(current.replace(/,/g, ''));
      } else if (typeof current === 'number') {
        return current;
      } else {
        throw new Error('Invalid input type');
      }
    } else {
      return 0;
    }
  }

  loadLocalData() {
    this.unit = this._localStorageService.getItem('sectorSelect');
  }

  changeNoSockCount(array1: any[], array2: any[]): boolean {
    if(array1 && array2){
      if (array1.length !== array2.length) {
        return false;
      }

      for (let i = 0; i < array1.length; i++) {
        const obj1 = array1[i];
        const obj2 = array2.find((o) => o.sku === obj1.sku && o.stock === obj1.stock);
        if (!obj2 || obj2.count !== obj1.count && obj1.stock === true ) {
          return true;
        }
      }

      return false;
    }
    return false
  }

  changeCount(e, p, index) {
    this.countProduct.emit({ e, p });
    this.ref.detectChanges();
    const refInput = this.referenceInput.find((_, i) => i == index);
    if (refInput) {
      refInput.nativeElement.select();
    }
  }

  delete(p) {
    this.deleteProduct.emit(p);
  }
  clean() {
    this.deleteCar.emit();
  }
  orderConfirmation() {
    if(this.changeNoSockCount(this.car.products, this.tempCar)){
      this.selectConfirmationNoStock.emit();
    } else {
      this.selectConfirmationStock.emit();
    }
    this.tempCar = this.car.products;
  }
  evaluateValue(p, index) {
    if (p.count == '' || p.count == 0) {
      this.changeCount('1', p, index);
      const refInput = this.referenceInput.find((_, i) => i == index);
      const refInputResponsive = this.referenceInput.find((_, i) => i == index);
      refInput?.nativeElement.classList.add('animation');
      refInputResponsive?.nativeElement.classList.add('animation');
    }
  }
}
